import TransactionSession from './transaction-session';

const transactionSessionInstance = new TransactionSession();

export default transactionSessionInstance;
